import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import styles from './Drawer.module.sass'

const Drawer = ({ open, position, classes, children }) => {
  const defaultClasses = {
    [styles.drawer]: true,
    [styles[position]]: true,
    [styles.closed]: !open
  }

  return (
    <div className={cn(defaultClasses, classes)}>
      {children}
    </div>
  )
}

Drawer.defaultProps = {
  position: 'left'
}

export default Drawer;
